import {
  AIRBNB_SEO_INLINE,
  DEFAULT_MODULES_POSITION,
  DISCARDED_MODULES,
  ESTABLISHMENT_MODULE_TYPES,
  PAGINATION_MODULES,
  REL_PER_MODULE,
  TIPOLOGY,
  TIPOLOGY_DESTINATIONS,
} from 'server/routes/seo/constants';
import { DOMAIN_COUNTRY, getCulture } from 'server/services/country';
import ApiJs from 'service-client-js';
import { createEstablishment } from 'service-client-js/app/lib/models/Establishment';
import { domainIDMatching } from 'helpers/holidu';
import { get } from 'server/services/request-promise';
import { processPartner } from 'service-client-js/app/lib/Partners';


export function parseSubhomeData(data) {
  const modules = getSubhomeModules(data);
  const { breadcrumb, menu, relateds } = data;
  const meta = { metadescription: data.metadescription, title: data.destInfo.title };
  return { body: 'page-landing', breadcrumb, coverSection: data.coverSection, menu, meta, modules, relateds };
}

export async function parseData(response, req, isPaginationPage, isEstablishmentPage, isTipologyPage) {
  ApiJs.setConfig({ DOMAIN_CULTURE: getCulture(req.country) });
  const { data } = response.data;
  const parsedModules = [];
  const pageType = data.meta.destination.page_type;
  const destination = await getDestination(data, req);

  if (data.modules) {
    data.modules.forEach((module) => {

      if (ESTABLISHMENT_MODULE_TYPES.includes(module.type)) {
        const establishmentsModule = module.data.map((establishment) => {
          establishment.id = getId(establishment);
          const estab = createEstablishment(establishment);
          estab.href = destination.path || '/s';
          estab.follow = false;
          return estab;
        });
        module.data = establishmentsModule;
      }

      if (!isPaginationPage && module.type === ESTABLISHMENT_MODULE_TYPES[0]) {
        module.data.pop();
        module.data.splice(0, 0, AIRBNB_SEO_INLINE);
      }

      if (isTipologyPage && PAGINATION_MODULES.includes(module.type)) {
        module = Object.assign({}, module, {
          data: TIPOLOGY,
          numPage: data.meta.num_page,
          numPages: data.meta.num_pages,
          tipology: data.meta.tipology,
        });
      }

      if (module.position === -1) module.position = DEFAULT_MODULES_POSITION[module.type] || -1;
      if (isValidModule(module)) parsedModules.push(module);
    });

    data.body = 'page-landing';
  }

  if (isEstablishmentPage && data.establishment) {
    const { description, matching_publications: matchingPublications, seo_id: seoId } = data.establishment;
    data.establishment = createEstablishment(data.establishment);
    if (matchingPublications) matchingPublications.forEach((partner) => { partner.clickout = `/hr/clickout/${partner.partner_id}/${seoId}/`; });
    data.establishment.matching_publications = matchingPublications;
    data.establishment.description = description;
    data.body = 'page-landing establishment';
  }

  if (isTipologyPage) data.meta.destination = destination;
  if (data.meta.num_pages > 1) parsedModules.push(getPaginatorModule(req, data));
  if (data.partners) data.partners = processPartner({ data: data.partners });

  data.modules = parsedModules;
  data.meta.pageType = pageType;
  return data;
}

export function isValidModule(module) {
  if (DISCARDED_MODULES.includes(module.type)) return false;
  if (module.data instanceof Array) return !!module.data.length;
  if (module.data instanceof Object) return !!Object.keys(module.data).length;
  if (typeof module.data === 'string') return !!module.data.length;
  if (typeof module.data === 'undefined') return true;
  return false;
}

export function getPaginatorModule(req, data) {
  return {
    data: {
      currentPage: data.meta.num_page,
      location: req.originalUrl,
      numberOfLinks: data.meta.num_page < 4 ? 7 - data.meta.num_page : 3,
      numPages: data.meta.num_pages,
    },
    position: 99,
    type: 'paginator',
  };
}

export async function getDestination(data, req) {
  const { destination } = data.meta;
  try {
    const response = await get(
      `https://www.holidu.com/rest/v6/search/autocomplete/${destination.location}?domainId=${domainIDMatching[DOMAIN_COUNTRY[req.country]]}`
    );
    return {
      country: destination.country_code,
      is_new: false,
      lat: Number(destination.latitude),
      lat_ne: Number(destination.bounding_box.latitude_ne),
      lat_sw: Number(destination.bounding_box.latitude_sw),
      lng: Number(destination.longitude),
      lng_ne: Number(destination.bounding_box.longitude_ne),
      lng_sw: Number(destination.bounding_box.longitude_sw),
      name: `${destination.location}, ${destination.country}`,
      path: response.data.items[0].pathname,
      place_id: destination.place_id,
      polygon_id: null,
    };
  } catch (e) {
    return TIPOLOGY_DESTINATIONS[req.country];
  }
}

function getSubhomeModules(data) {
  const modules = [];
  modules.push(Object.assign({}, data.textSection, { type: 'textSection' }));
  for (let i = 0, j = REL_PER_MODULE; i < data.relateds.length; i += REL_PER_MODULE, j += REL_PER_MODULE) {
    modules.push({ data: data.relateds.slice(i, j), position: i, type: 'relateds' });
  }
  return modules;
}

export function imagify(url, width = null) {
  if (url && url.includes('demo.holidu')) {
    return url.replace('http://demo.holidu.com', 'https://r.100r.systems');
  }
  if (!url) {
    return url;
  }
  let newUrl = url.replace('res.cloudinary.com/hundredrooms', 'r.100r.systems');
  if (!newUrl.includes('r.100r.systems')) newUrl = `https://r.100r.systems/image/fetch/${encodeURIComponent(url)}`;
  if (!width || isNaN(width)) return newUrl;
  const options = `f-auto-w-${width}-c-limit`;
  const parts = newUrl.split('/');
  const widthIndex = parts.findIndex(item => item.startsWith('w_'));
  if (widthIndex !== -1) {
    parts.splice(widthIndex, 1);
    return parts.join('/');
  }
  let index = parts.indexOf('upload');
  if (index === -1) index = parts.indexOf('fetch');
  if (index === -1) return newUrl;
  parts.splice(index + 1, 0, options);
  return parts.join('/');
}


function getId(estab) {
  if (!estab.url) return estab.id;
  const url = estab.url.split('-');
  return url[url.length - 1];
}
